const parseClassNames = (...classNames: string[]) => {
  return classNames.join(' ')
}

export default parseClassNames
